import {
  Paper,
  Stack,
  useTheme,
  Typography,
  TextField,
  Grid,
  Checkbox,
  Link,
  Button,
  Box,
  Snackbar,
  Alert,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";

import { ChangeEvent, useEffect, useState } from "react";
import useStyles from "./styles";
import { useNavigate } from "react-router-dom";
import { validarEmail, validarSenha } from "../../utils/validateFields";
import axios, { AxiosError } from "axios";
import "./checkAnimation.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNotification } from "../../componentes/notificationProvider";

export default function Cadastro(): JSX.Element {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  // Estados dos campos do formulário
  const [email, setEmail] = useState<string>("");
  const [senha, setSenha] = useState<string>("");
  const [confirmarSenha, setConfirmarSenha] = useState<string>("");
  const [aceitouTermos, setAceitouTermos] = useState<boolean>(false);
  const [checkSenha, setCheckSenha] = useState<boolean>(false);
  const [checkCaracterSenha, setCheckCaracterSenha] = useState<boolean>(false);
  const [checkEmail, setCheckEmail] = useState<boolean>(false);
  const url = (window as any)?.config?.REACT_APP_BASE_URL || "";
  const [cadastrado, SetCadastrado] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setCofirmShowPassword] = useState<boolean>(false);
  const notify = useNotification();
  useEffect(() => {
    setCheckSenha(confirmarSenha == senha);
    setCheckCaracterSenha(validarSenha(senha));
    setCheckEmail(validarEmail(email));
  }, [senha, confirmarSenha, email]);

  // funções da Api
  async function handleApi() {
    if (!checkCaracterSenha || !checkSenha || !aceitouTermos || !checkEmail) {
      return;
    }

    try {
      //let response = {};
      const response = await axios.post(`${url}/public/usuario/create`, {
        email,
        senha,
      });

      SetCadastrado(true);
      notify(null, "Usuário cadastrado com sucesso!", "success");
    } catch (error) {
      console.error(error);
      if (error instanceof AxiosError && error?.response?.data && error.status)
        notify(error.status, undefined, "error", error);
      else notify(null, "Erro ao cadastrar novo usuário!", "error");
    }
  }

  return (
    <>
      <Stack
        direction={"column"}
        spacing={2}
        justifyContent={"center"}
        alignItems={"center"}
        sx={styles.stackPage}
      >
        <Paper sx={styles.paperForm}>
          {!cadastrado && (
            <>
              <Stack justifyContent={"center"} alignItems={"center"}>
                <Typography sx={styles.title}>Crie sua Conta</Typography>
                <Typography sx={styles.subtitle}>
                  Inscreva-se para acessar os recursos do sistema
                </Typography>
              </Stack>

              <Grid container spacing={1}>
                <Grid size={16}>
                  <Typography sx={styles.sectionTitle}>
                    Informações da conta
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <TextField
                    name="userEmail"
                    autoComplete="off"
                    value={email}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setEmail(e.target.value)
                    }
                    error={email != "" && !checkEmail}
                    helperText={
                      email != "" && !checkEmail ? "E-mail inválido" : ""
                    }
                    label="Email"
                    size="small"
                    variant="filled"
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    name="userSenha"
                    autoComplete="new-password"
                    value={senha}
                    type={showPassword ? "text" : "password"}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setSenha(e.target.value)
                    }
                    label="Senha"
                    error={senha != "" && !checkCaracterSenha}
                    helperText={
                      senha != "" && !checkCaracterSenha
                        ? "A senha deve ter pelo menos 6 caracteres e conter letras e números"
                        : ""
                    }
                    size="small"
                    variant="filled"
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <Stack direction={"row"} gap={0.5}>
                              <Tooltip
                                title={!showPassword ? "Mostrar" : "Ocultar"}
                                placement="top"
                              >
                                <span>
                                  <IconButton
                                    //sx={styles.iconButton}
                                    //disabled={!statusLink}
                                    edge="end"
                                    size="small"
                                    onClick={() => {
                                      setShowPassword((show) => !show);
                                    }}
                                  >
                                    {showPassword ? (
                                      <VisibilityOff
                                        sx={{
                                          color: theme.palette.text.disabled,
                                        }}
                                      />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>{" "}
                                </span>
                              </Tooltip>
                            </Stack>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    name="UserconfirmarSenha"
                    autoComplete="off"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmarSenha}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setConfirmarSenha(e.target.value)
                    }
                    helperText={
                      confirmarSenha != "" && !checkSenha
                        ? "As senhas não coincidem"
                        : ""
                    }
                    error={confirmarSenha != "" && !checkSenha}
                    label="Confirmar Senha"
                    size="small"
                    variant="filled"
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <Stack direction={"row"} gap={0.5}>
                              <Tooltip
                                title={
                                  !showConfirmPassword ? "Mostrar" : "Ocultar"
                                }
                                placement="top"
                              >
                                <span>
                                  <IconButton
                                    //sx={styles.iconButton}
                                    //disabled={!statusLink}
                                    edge="end"
                                    size="small"
                                    onClick={() => {
                                      setCofirmShowPassword((show) => !show);
                                    }}
                                  >
                                    {showConfirmPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>{" "}
                                </span>
                              </Tooltip>
                            </Stack>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Stack {...styles.termsStack} direction="row">
                <Checkbox
                  checked={aceitouTermos}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setAceitouTermos(e.target.checked)
                  }
                />
                <Typography sx={styles.termsText}>
                  Eu Aceito os
                  <Link sx={styles.link}>termos de uso</Link>
                </Typography>
              </Stack>

              <Button
                disabled={
                  !checkCaracterSenha ||
                  !checkSenha ||
                  !aceitouTermos ||
                  !checkEmail
                }
                onClick={() => handleApi()}
                fullWidth
                variant="contained"
              >
                Continue
              </Button>

              <Typography sx={styles.loginText}>
                Já tem uma conta?
                <Link sx={styles.link}>Conecte-se</Link>
              </Typography>
            </>
          )}
          {cadastrado && (
            <>
              <Stack justifyContent={"center"} alignItems={"center"} gap={3}>
                <Box className="success-animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </Box>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <Typography sx={styles.title}>Usuário Criado!</Typography>
                  <Typography sx={styles.subtitle}>
                    Entre agora e aproveite tudo o que o sistema oferece!
                  </Typography>
                </Stack>

                <Button
                  onClick={() => navigate("/login")}
                  fullWidth
                  variant="contained"
                >
                  Fazer Login
                </Button>
              </Stack>
            </>
          )}
        </Paper>
      </Stack>
    </>
  );
}
